import { App } from 'vue';

import { initDomVariables } from './dom/dom';
import { dictionaryConfig } from './dictionary/dictionary';
import animationConfig from './animation';
import iconConfig from './icons/icons.config';
import componentsConfig from './components';
import filterConfig from './filters/filters.config';
import formsConfig from './forms/forms.config';
import directivesConfig from './directives/directives.config';
import popoverConfig from './popover/popover.config';
import responsiveConfig from './responsive/responsive.config';
import draggableConfig from './drag-n-drop/draggable.config';
import richTextEditorConfig from './rich-text-editor/richTextEditor.config';
import colorPickerConfig from './color/picker/colerPicker.config';
import splitPanesconfig from './panes/splitPanes.config';
import swiperConfig from './swiper/swiper.config';
import sliderConfig from './slider';
import contextMenuConfig from './context-menus';
import dateFnsConfig from './date-fns';
import genericConfig from './generic';
import { startDictionaryMissingLabelsQueue } from './dictionary/dictionaryMissingLabelsQueue';
import { MarkLabelAsMissingRequest } from '@/api';

export default async function config(app: App, missingDictionaryLabelsCaller: (request: MarkLabelAsMissingRequest) => Promise<boolean | undefined>): Promise<void> {
    dictionaryConfig(app);
    initDomVariables();
    animationConfig(app);
    iconConfig(app);
    componentsConfig(app);
    filterConfig(app);
    formsConfig(app);
    popoverConfig(app);
    directivesConfig(app);
    responsiveConfig(app);
    draggableConfig(app);
    richTextEditorConfig(app);
    colorPickerConfig(app);
    splitPanesconfig(app);
    swiperConfig(app);
    sliderConfig(app);
    contextMenuConfig(app);
    dateFnsConfig();
    genericConfig(app);

    startDictionaryMissingLabelsQueue(missingDictionaryLabelsCaller);
}
